__turbopack_context__.v({
  "react_player": "styles-module__XrVQSG__react_player",
  "videoContainer": "styles-module__XrVQSG__videoContainer",
});
